// extracted by mini-css-extract-plugin
export var wrapper = "RCALogo-module--wrapper--00be6";